import { cloneDeep, isEqual } from 'lodash'

import { proxy } from '@/utils'

import render from './render'

const defaultRule = { conditions: [] }

export default {
  name: 'TariffsRulesGroup',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    index: Number,
    source: String
  },

  computed: {
    hasRules() {
      return this.proxy && Array.isArray(this.proxy.rules) && this.proxy.rules.length
    }
  },

  methods: {
    _inputFilter(data) {
      if (!Array.isArray(data.rules)) {
        data.rules = []
      }

      return data
    },
    transmitValue() {
      if (!isEqual(this.proxy, this.value)) {
        this.$emit('input', cloneDeep(this.proxy))
      }
    },

    updatePriceRanges(priceRanges) {
      this.proxy = {
        ...this.proxy,
        priceRanges
      }
    },

    updateRuleConditions(index, conditions) {
      const rules = this.proxy.rules.slice()
      const rule = rules[index] || {}

      rules.splice(index, 1, {
        ...rule,
        conditions
      })

      this.proxy = {
        ...this.proxy,
        rules
      }
    },

    removeRuleConditions(index) {
      const rules = this.proxy.rules.slice()

      rules.splice(index, 1)

      this.proxy = {
        ...this.proxy,
        rules
      }
    },

    addConditions() {
      this.proxy.rules.push(cloneDeep(defaultRule))
    }
  },

  render
}
